import React from 'react';
import { Check } from 'lucide-react';
import { workflowStages } from '../../data/cngs';
import { toBn } from '../../utils/bn';
interface WorkflowTimelineProps {
  stage: number;
  orientation?: 'horizontal' | 'vertical';
  meta?: string[];
}
export function WorkflowTimeline({
  stage,
  orientation = 'horizontal',
  meta
}: WorkflowTimelineProps) {
  if (orientation === 'vertical') {
    return <ol className="relative space-y-0" data-id="element-179" data-mp="2t29yrj879qbo">
        {workflowStages.map((s, i) => {
        const done = i < stage || stage === 7;
        const current = i === stage && stage !== 7;
        return <li key={s.key} className="relative flex gap-3 pb-5 last:pb-0" data-id="element-180" data-mp="2jb5kymu9gbif" data-mpi={i}>
              {i < workflowStages.length - 1 && <span className={`absolute left-[13px] top-7 h-[calc(100%-20px)] w-0.5 ${done ? 'bg-bdgreen-600' : 'bg-slate-200'}`} aria-hidden data-id="element-181" data-mp="2f9ty2p2ru4dx" />}
              <span className={`relative z-10 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 text-xs font-semibold ${done ? 'border-bdgreen-600 bg-bdgreen-600 text-white' : current ? 'border-amber-500 bg-amber-50 text-amber-700' : 'border-slate-300 bg-white text-slate-400'}`} data-id="element-182" data-mp="3719jwgwi7n33">
                {done ? <Check className="h-3.5 w-3.5" strokeWidth={3} data-id="element-183" data-mp="3je4ke3yxjs48" /> : toBn(i + 1)}
              </span>
              <div className="pt-0.5" data-id="element-184" data-mp="35ewj95j7i9xe">
                <p className={`text-sm font-semibold ${done ? 'text-navy-900' : current ? 'text-amber-700' : 'text-slate-400'}`} data-id="element-185" data-mp="35dtup49cwjkn">
                  {s.label} <span className="font-normal text-xs text-slate-400" data-id="element-186" data-mp="3abd8k3256uc2">({s.en})</span>
                </p>
                <p className="text-xs text-muted-foreground" data-id="element-187" data-mp="30fjxyp7zhawx">
                  {current ? 'বর্তমান ধাপ — কার্যক্রম প্রয়োজন' : meta?.[i] ?? (done ? 'সম্পন্ন' : 'অপেক্ষমাণ')}
                </p>
              </div>
            </li>;
      })}
      </ol>;
  }
  return <ol className="flex w-full items-start overflow-x-auto pb-1" data-id="element-188" data-mp="ym2qpmnrmc2p">
      {workflowStages.map((s, i) => {
      const done = i < stage || stage === 7;
      const current = i === stage && stage !== 7;
      return <li key={s.key} className="flex min-w-[92px] flex-1 flex-col items-center text-center" data-id="element-189" data-mp="n8ka6nm84xeq" data-mpi={i}>
            <div className="flex w-full items-center" data-id="element-190" data-mp="j7i8m04u499l">
              <span className={`h-0.5 flex-1 ${i === 0 ? 'opacity-0' : done || current ? 'bg-bdgreen-600' : 'bg-slate-200'}`} data-id="element-191" data-mp="j8td6263tl1r" />
              <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 text-xs font-bold ${done ? 'border-bdgreen-600 bg-bdgreen-600 text-white' : current ? 'border-amber-500 bg-amber-50 text-amber-700' : 'border-slate-300 bg-white text-slate-400'}`} data-id="element-192" data-mp="1fzc1p7scgxvq">
                {done ? <Check className="h-4 w-4" strokeWidth={3} data-id="element-193" data-mp="1yosdir9hccrg" /> : toBn(i + 1)}
              </span>
              <span className={`h-0.5 flex-1 ${i === workflowStages.length - 1 ? 'opacity-0' : done ? 'bg-bdgreen-600' : 'bg-slate-200'}`} data-id="element-194" data-mp="1twh5t28hzmoc" />
            </div>
            <p className={`mt-2 px-1 text-xs font-semibold ${done ? 'text-navy-900' : current ? 'text-amber-700' : 'text-slate-400'}`} data-id="element-195" data-mp="3hitvdnoxwxra">{s.label}</p>
            <p className="text-[10px] text-slate-400" data-id="element-196" data-mp="3lj5gt2p4n23t">{s.en}</p>
          </li>;
    })}
    </ol>;
}